import bedroom1 from './bedroom1.jpg';
import bedroom2 from './bedroom2.jpg';
import bedroom3 from './bedroom3.jpg';
import bedroom4 from './bedroom4.jpg';
import bedroom5 from './bedroom5.jpg';
import bedroom6 from './bedroom6.jpg';
import bedroom7 from './bedroom7.jpg';

export const bedroomImages: string[] = [
    bedroom1,
    bedroom2,
    bedroom3,
    bedroom4,
    bedroom5,
    bedroom6,
    bedroom7,
];
